<template>
  <div class="tip-page">
    <div class="tip-page-top">
      <span>{{ data.label || '信息' }}
      </span>
      <el-tooltip
          class="item"
          effect="dark"
          content="关闭"
          placement="top-start"
      >
        <i @click="handleCloseTip" class="el-icon-close"></i>
      </el-tooltip>
    </div>
    <div class="tip-page-content">
      <el-row :span="24">
        <el-col :span="24">
          <div class="item-content">
            <label class="item-label">碳排放量 ：</label>
            <span class="item-value">{{ data.carbonEmission || 0 }}</span>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "polygonTip",
  components: {},
  data() {
    return {
      labelSpan: 11,
      data: {}, //渲染数据
    };
  },
  mounted() {
    console.info('触发')
  },
  methods: {
    handleCloseTip() {
      this.$emit("tipClose");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";
.flex-Between {
  display: flex;
  justify-content: space-between;
  //
}
$bgcolor: rgba(30, 40, 64, 1);
.tip-page {
  padding: 10px 15px;
  height: auto;
  font-size: 15px;
  border-radius: 5px;
  @include set_theme_color(background-color, map-panel-content);
  backdrop-filter: blur(2px);
  &-top {
    border-left: 5px solid #407aee;
    padding-left: 10px;
    height: 20px;
    line-height: 20px;
    @extend .flex-Between;
    .titleAudio {
      font-size: 14px;
      color: #ffbf00;
    }
    .titleCall {
      font-size: 14px;
      color: rgba(30, 205, 127, 1);
    }
    i {
      cursor: pointer;
      font-size: 18px;
      // color: #fff;
      @include set_theme_color(color, main-theme-color);
      position: absolute;
      top: 10px;
      right: 10px;
      pointer-events: all;
      padding: 2px;
      &:hover {
        // background: $bgcolor;
        border-radius: 50%;
        -webkit-animation: rotation 5s linear infinite;
        animation: rotation 5s linear infinite;
      }
    }
  }
  &-content {
    margin-top: 12px;
    .item-content {
      font-size: 15px;
      margin: 8px 0;
      display: flex;
      flex-direction: row;
    }
    .el-col {
      margin-right: 10px;
    }
    .item-label {
      // width: 80px;
    }
    .item-value {
      //   max-width: 220px;
    }
  }
  &-bottom {
    padding: 5px;
    text-align: center;
  }
}
@keyframes rotation {
  0% {
    -webkit-transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
  }
}
</style>
